/*
 * @providesModule LTOComponentStyle
 *
 */

import SkillzStyle from 'SkillzStyle';
import Sizes from 'Sizes';
import {default as ComponentStyles} from 'ComponentStyles';

import {StyleSheet, Platform} from 'react-native';
import {backgroundColor} from 'app/AccountMenu/SMSVerification/SMSVerification.style';

const {
  fontSizeH1,
  fontSizeH2,
  fontSizeH3,
  fontSizeH4,
  fontSizeH5,
  fontSizeLarge,
  fontSecondary,
  fontRegular,
  fontBold,
  fontDigital,
  btnTextColorOne,
  textColorPrimary,
  textColorCash,
  textColorDepositTile,
  textColorSecondary,
  viewCornerRadiusSecondary,
} = SkillzStyle.sheetStyles;

export default StyleSheet.create({
  divider: {
    position: 'absolute',
    top: 0,
    right: 0,
    left: 0,
    height: 1,
    marginBottom: 10,
  },

  contentContainer: {
    backgroundColor: 'transparent',
    alignItems: 'center',
    ...Sizes.select({
      landscapePhone: {
        flexDirection: 'row',
      },
      portraitPhone: {
        flexDirection: 'column',
        marginHorizontal: 15,
      },
      other: {
        flexDirection: 'column',
      },
    }),
  },

  depositTile: {
    alignSelf: 'center',
    ...Sizes.select({
      landscapePhone: {
        width: 200,
        height: 110,
      },
      portraitPhone: {
        width: 220,
        height: 110,
      },
      other: {
        width: 270,
        height: 150,
      },
    }),
    backgroundColor: 'transparent',
  },

  buttonText: {
    backgroundColor: 'transparent',
    textAlign: 'center',
    fontSize: Sizes.dynamic({
      sm: fontSizeH3.fontSize,
      lg: fontSizeH1.fontSize,
    }),
    marginHorizontal: 10,
    ...btnTextColorOne,
    ...fontSecondary,
  },

  buttonComponent: {
    marginHorizontal: 5,
    height: Sizes.dynamic({
      sm: 30,
      lg: 50,
    }),
    marginTop: 15,
    marginBottom: 6,
  },

  ltoTextContainer: {
    backgroundColor: 'transparent',
    alignItems: 'center',
    ...Sizes.select({
      landscapePhone: {
        marginRight: 4,
      },
      other: {},
    }),
  },

  headerText: {
    alignSelf: 'center',
    textAlign: 'center',
    marginHorizontal: 0,
    ...Sizes.select({
      landscapePhone: {},
      other: {
        marginTop: 12,
      },
    }),
    fontSize: Sizes.select({
      phoneLandscape: fontSizeH2.fontSize,
      other: fontSizeH1.fontSize,
    }),
    ...fontBold,
    ...textColorSecondary,
  },

  detailText: {
    marginVertical: 10,
    paddingHorizontal: 16,
    textAlign: 'center',
    fontSize: Sizes.orientation({
      portrait: fontSizeH3.fontSize,
      landscape: fontSizeH4.fontSize,
    }),
    ...fontRegular,
    ...textColorSecondary,
  },

  subheaderText: {
    textAlign: 'center',
    fontSize: Sizes.select({
      phoneLandscape: fontSizeH3.fontSize,
      phonePortrait: fontSizeH2.fontSize,
      other: fontSizeH1.fontSize,
    }),

    ...fontRegular,
    ...textColorSecondary,
  },

  countdownContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: Sizes.select({
      phoneLandscape: 6,
      other: 14,
    }),
  },

  countdownDetailText: {
    ...fontSizeH3,
    ...fontRegular,
    ...textColorPrimary,
  },

  countdownTimeText: {
    ...fontSizeH2,
    ...fontDigital,
    ...textColorCash,
  },

  offerContainer: {
    alignSelf: 'center',
    backgroundColor: textColorSecondary.color,
    marginHorizontal: 0,
    ...Sizes.select({
      phoneLandscape: {
        marginVertical: 4,
        marginLeft: 4,
      },
      other: {
        marginTop: 8,
      },
    }),
    padding: Sizes.select({
      phone: 5,
      other: 10,
    }),
    borderRadius: viewCornerRadiusSecondary.borderRadius,
  },

  storeFrontLTOContainer: {
    minHeight: 120,
    marginBottom: 8,
    marginTop: 2,
    borderRadius: viewCornerRadiusSecondary.borderRadius,
    ...ComponentStyles.container1,
  },

  storeFrontLTO: {
    flexGrow: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },

  storeFrontLTOButton: {
    height: 82,
  },

  storeFrontLTOButtonWrapper: {
    marginTop: 30,
    ...Sizes.select({
      landscapephone: {
        alignSelf: 'center',
      },
      other: {
        alignSelf: 'stretch',
        marginHorizontal: 10,
        marginBottom: 10,
      },
    }),
  },

  storeFrontLTOTextContainer: {
    marginBottom: -30,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    ...Sizes.dynamic({
      phone: {
        width: 510,
      },
      tablet: {
        width: '100%',
        marginHorizontal: 13,
        paddingHorizontal: 10,
      },
    }),
  },

  limitedTimeOfferText: {
    flexGrow: 1,
    ...fontSizeH2,
    ...fontBold,
    ...textColorSecondary,
    textAlignVertical: 'center',
    marginVertical: 5,
  },

  endsInText: {
    ...fontSizeH3,
    ...textColorSecondary,
    ...fontRegular,
  },

  storeFrontCountdownText: {
    ...fontSizeH3,
    ...textColorSecondary,
    ...fontRegular,
  },

  bonusCashText: {
    backgroundColor: 'transparent',
    alignSelf: 'flex-start',
    ...textColorDepositTile,
    ...fontSecondary,
    ...fontSizeLarge,
    paddingHorizontal: 15,
  },

  depositText: {
    backgroundColor: 'transparent',
    alignSelf: 'flex-end',
    ...textColorDepositTile,
    ...fontSecondary,
    ...fontRegular,
    ...fontSizeH2,
    paddingHorizontal: 15,
  },

  storeFrontLTOButtonContents: {
    flexGrow: 1,
    alignItems: 'center',
    alignSelf: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
    width: '100%'
  },

  // ----------------------- iPhone Styles -------------------------------
  //TODO Refactor to share more with iPad Styles.
  backingView: {
    marginBottom: 6,
    borderRadius: viewCornerRadiusSecondary.borderRadius,
    ...Sizes.dynamic({
      phone: {
        marginHorizontal: 0,
      },
      tablet: {
        marginHorizontal: 6,
      },
    }),
  },

  touchableOpacity: {
    backgroundColor: 'transparent',
    ...viewCornerRadiusSecondary,
    margin: 0,
    padding: 0,
  },

  mainView: {
    flexDirection: 'column',
    backgroundColor: 'white',
    minHeight: 76,
    paddingVertical: 3,
    ...viewCornerRadiusSecondary,
  },

  topView: {
    flexDirection: 'row',
    flexWrap: 'nowrap',
    justifyContent: 'space-between',
    backgroundColor: 'transparent',
    alignItems: 'center',
  },

  limitedTimeOfferTextPhone: {
    backgroundColor: 'transparent',
    textAlign: 'left',
    marginLeft: 5,
    verticalAlign: 'middle',
    ...textColorSecondary,
    ...fontSizeH4,
    ...fontSecondary,
  },
  endsInTextPhone: {
    backgroundColor: 'transparent',
    textAlign: 'right',
    marginRight: 5,
    ...fontRegular,
    ...textColorSecondary,
    ...fontSizeH4,
  },
  bonusCashTextPhone: {
    ...Platform.select({
      native: {
        shadowColor: 'black',
        shadowOffset: {width: 0, height: 1},
      },
    }),
    ...textColorDepositTile,
    ...fontSizeH2,
    ...fontSecondary,
  },
  promoBonusCashTextPhone: {
    ...fontRegular,
    ...textColorDepositTile,
    ...fontSizeH4,
    marginBottom: Platform.select({ios: 2, android: -2}),
  },
  phoneStoreBonusCashWrapper: {
    backgroundColor: 'transparent',
    alignSelf: 'center',
    marginLeft: 4,
  },
  depositFrame: {
    flexDirection: Sizes.select({
      tablet: 'row',
      phone: 'column',
    }),
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 4,
    minHeight: 40,
  },
  depositAmountText: {
    backgroundColor: 'transparent',
    alignSelf: 'center',
    textAlign: 'center',
    ...fontRegular,
    ...fontSizeH5,
    ...textColorDepositTile,
    marginRight: Sizes.select({
      tablet: 5,
      phone: 0,
    }),
    lineHeight: fontSizeH5.fontSize + 2,
  },
  depositTextPhone: {
    backgroundColor: 'transparent',
    alignSelf: 'center',
    textAlign: 'center',
    ...fontRegular,
    ...fontSizeH4,
    ...textColorDepositTile,
    lineHeight: fontSizeH4.fontSize + 2,
  },
  gradientFrame: {
    flexGrow: 1,
    backgroundColor: 'transparent',
    ...Sizes.dynamic({
      phone: {
        marginHorizontal: 5,
        marginVertical: 3,
      },
    }),
  },

  gradient: {
    padding: 4,
    ...viewCornerRadiusSecondary,
    flexGrow: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },

  mainContainer: {
    justifyContent: 'center',
    marginTop: 12,
    marginHorizontal: 10,
    borderRadius: viewCornerRadiusSecondary.borderRadius,
  },

  mainContainerPlayTab: {
    marginHorizontal: 0,
    marginBottom: -4,
  },
});
